// extracted by mini-css-extract-plugin
module.exports = {"fixedButton":"FixedButton_fixedButton__3HgyM","Btn1":"FixedButton_Btn1__uIX7A","Btn2":"FixedButton_Btn2__-RWq0"};